import {
  Card,
  DataStatus,
  Form,
  FormButton,
  FormField,
  FormSubmitHandler,
} from 'platform/components';
import {Right, VStack} from 'platform/foundation';

import {
  useGetTipCarsDefaultSettingsQuery,
  useSetTipCarsDefaultSettingsMutation,
} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

type PlatformTipCarsVinFormData = {
  vinHidden: boolean;
};

export function PlatformTipCarsVin() {
  const branchId = useBranchId();
  const {data, isLoading, isError} = useGetTipCarsDefaultSettingsQuery({
    branchId,
  });
  const [saveSettings] = useSetTipCarsDefaultSettingsMutation();

  const onSubmit: FormSubmitHandler<PlatformTipCarsVinFormData> = (values) =>
    saveSettings({...values, branchId})
      .unwrap()
      .catch(handleApiError);

  return (
    <Card title={i18n.t('general.labels.defaultSettings')}>
      <DataStatus isLoading={isLoading} isError={isError}>
        <Form<PlatformTipCarsVinFormData>
          defaultValues={data}
          onSubmit={onSubmit}
          shouldWatchForUnsavedChanges
        >
          {(control) => (
            <VStack spacing={4}>
              <FormField
                control={control}
                name="vinHidden"
                type="switch"
                label={i18n.t('page.settings.labels.vinHidden')}
              />
              <Right>
                <FormButton
                  control={control}
                  type="submit"
                  title={i18n.t('general.actions.save')}
                />
              </Right>
            </VStack>
          )}
        </Form>
      </DataStatus>
    </Card>
  );
}
